export enum BrainPlatform {
  OPENAI = 'openai',
  DOUBAO = 'doubao',
  // DIFY = 'dify',
}

// export enum OpenAIModel {
//     GPT_4O_MINI = 'gpt-4o-mini',
//     GPT_4O = 'gpt-4o',
//     GPT_4 = 'gpt-4',
//     GPT_3_5_TURBO = 'gpt-3.5-turbo',
// }

interface BrainSettingsMap {
  [BrainPlatform.OPENAI]: {
    model: string
  }
  [BrainPlatform.DOUBAO]: {
    model: string
  }
  // [BrainPlatform.DIFY]: {
  //     apiKey: string
  //     baseURL: string
  // }
}

interface BrainType<T extends BrainPlatform> {
  platform: T
  settings: BrainSettingsMap[T]
}
export type Brain = BrainType<BrainPlatform.OPENAI> | BrainType<BrainPlatform.DOUBAO>

export const defaultBrain: Brain = {
  platform: BrainPlatform.OPENAI,
  settings: {
    model: 'gpt-4o-mini',
  },
}
